// Cấu hình routes cho ứng dụng
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

// Pages
import HomePage from "../pages/HomePage";
import ColorPalettePage from "../pages/ColorPalettePage";

// Auth Feature
import {
  LoginPage,
  RegisterPage,
  ForgotPasswordPage,
  ChangePasswordPage,
} from "../features/auth";

// Host Feature
import { HostList, HostDetailPage } from "../features/host";

import SubscriptionRoute from "./SubscriptionRoute";
import LockedPage from "../features/subscription/pages/LockedPage";

// Admin Feature
import AdminRoute from "./AdminRoute";
import AdminLayout from "../features/admin/components/AdminLayout";
import AdminDashboard from "../features/admin/pages/AdminDashboard";
import PackageManagement from "../features/admin/pages/PackageManagement";
import PromotionManagement from "../features/admin/pages/PromotionManagement";
import UserManagement from "../features/admin/pages/UserManagement";
import OrderManagement from "../features/admin/pages/OrderManagement";
import SubscriptionManagement from "../features/admin/pages/SubscriptionManagement";
import TransactionManagement from "../features/admin/pages/TransactionManagement";

import OrderHistoryPage from "../features/subscription/pages/OrderHistoryPage";
import DepositPage from "../features/payment/pages/DepositPage";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      {process.env.NODE_ENV === "development" && (
        <Route path="/color-palette" element={<ColorPalettePage />} />
      )}

      <Route path="/home" element={<HomePage />} />
      <Route path="/orders" element={<PrivateRoute><OrderHistoryPage /></PrivateRoute>} />
      <Route path="/deposit" element={<PrivateRoute><DepositPage /></PrivateRoute>} />

      {/* Subscription Paywall Route */}
      <Route path="/locked" element={<PrivateRoute><LockedPage /></PrivateRoute>} />

      <Route
        path="/hosts"
        element={
          <PrivateRoute>
            <HostList />
          </PrivateRoute>
        }
      />
      <Route
        path="/hosts/:hostId"
        element={
          <PrivateRoute>
            <HostDetailPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/change-password"
        element={
          <PrivateRoute>
            <ChangePasswordPage />
          </PrivateRoute>
        }
      />

      {/* Admin Interface */}
      <Route
        path="/admin"
        element={
          <AdminRoute>
            <AdminLayout />
          </AdminRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="packages" element={<PackageManagement />} />
        <Route path="promotions" element={<PromotionManagement />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="orders" element={<OrderManagement />} />
        <Route path="transactions" element={<TransactionManagement />} />
        <Route path="subscriptions" element={<SubscriptionManagement />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
